import { Stack, Typography } from "@mui/material";
import { format, isToday } from "date-fns";

export default function ReservationDateRange({ reservation, hideTime, variant, fontWeight, hideStartTime, hideEndTime, ...props }) {
  const dateTimeFormat = hideTime ? 'LLL d' : 'LLL d @ h:mm aa';

  const startDate = new Date(reservation.start_at);
  const endDate = new Date(reservation.end_at);

  const isStartToday = isToday(startDate);
  const isEndToday = isToday(endDate);
  const isSameDay = startDate.getDate() === endDate.getDate() && !hideStartTime;

  const delineator = hideEndTime || hideStartTime ? '' : ' - ';
  const startString = hideStartTime ? '' : isStartToday ? `Today @ ${format(startDate, 'h:mm aa')}` : format(startDate, dateTimeFormat);
  const endString = hideEndTime ? '' : isSameDay ? (!hideTime && format(endDate, 'h:mm aa')) : isEndToday ? `Today @ ${format(endDate, 'h:mm aa')}` : format(endDate, dateTimeFormat);

  return (
    <Stack>
      <Typography variant={variant || "body1"} fontWeight={fontWeight || 700} {...props}>
        {startString} {delineator} {endString}
      </Typography>
    </Stack>
  );
}